import { FC } from 'react'

const COMPANY_NAME = 'Ant-App Limited'

/** Site footer: copyright line (DESIGN.md tokens, light only). */
export const Footer: FC<{ className?: string }> = ({ className = '' }) => (
    <footer className={`border-t border-line bg-canvas-deep/60 ${className}`}>
        <div className='mx-auto w-full max-w-content px-4 py-5 text-xs text-ink-faint sm:px-6 lg:px-8'>
            <p>版權所有 © {new Date().getFullYear()} {COMPANY_NAME}。保留一切權利。</p>
        </div>
    </footer>
)
